import script from "./CvProgressStep.vue?vue&type=script&setup=true&lang=js"
export * from "./CvProgressStep.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__